// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());


// WEBPACK FOOTER //
// ./scripts/main.js